/**
 * Dashboard - User's settings
 */

'use strict';

// Constructor
var FrontDashboardHome = function () {
    if (!$('body').hasClass('dashboard')) {
        return;
    }

    $(document).ready((function() {
        this.loadAddressData();
        this.submitAddressForm();
        this.init();
    }).bind(this));
};

FrontDashboardHome.prototype = {
    lockAjaxSendForm: false,

    init: function() {
        $('.dashboard-home-bottom-mh').matchHeight();
    },

    loadAddressData: function() {
        $('#dashboard-home .edit-address').on('click', function() {
            var userId = $(this).data('user');

            var form = $('#modal-address form');

            $('#address-country').change(function() {
                if ($(this).val() !== 'ch') {
                    $('#address-canton').parent().parent().addClass('hidden');
                } else {
                    $('#address-canton').parent().parent().removeClass('hidden');
                }
            });

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'dashboard.getaddress',
                    security: comedien.security,
                    userId: userId,
                }
            }).done(function (response) {
                if (response.success) {
                    
                    var info = response.data.user;

                    // Fill the fields
                    for (var key in info) { 
                        if (info[key].length > 0) {
                            if (key === 'address-country' || key === 'address-canton') {
                                form.find('#'+ key).find('option[value="'+ info[key] +'"]').prop('selected', true);
                                form.find('#'+ key).formSelect();
                            } else {
                                form.find('#'+ key).val(info[key]);
                                form.find('label[for='+ key +']').addClass("active");
                            } 
                        }
                    }

                    if ($('#address-country').val() !== 'ch') {
                        $('#address-canton').parent().parent().addClass('hidden');
                    } else {
                        $('#address-canton').parent().parent().removeClass('hidden');
                    }

                    $('#modal-address').modal('open');     
                } else {
                    // TODO: display a msg on screen
                    console.log('invalid nonce: ' + response);
                }
            }).fail(function (jqXHR, textStatus) {
                // TODO
                console.log("Request failed: " + textStatus);
            });
        });
    },

    /**
     * Update the user's data (address & phones).
     */
    submitAddressForm: function() {
        var self = this;

        var form = $('#modal-address form');

        form.submit(function(event) {
            event.preventDefault();

            if (self.lockAjaxForm) {
                // Pending AJAX request... do nothing
                return;
            }

            self.lockAjaxForm = true;

            var formdata = false;
            if (window.FormData){
                formdata = new FormData(form[0]);

                formdata.append('action', 'dashboard.address');
                formdata.append('security', comedien.security);
            }

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: formdata ? formdata : form.serialize() + "&action=comedien.address&security=" + comedien.security,
                contentType: false,
                processData: false,
                cache: false,
            }).done(function(response) {
                if (response.success) {
                    var html = response.data.html;

                    var parent = $('.section-data p.address').parent();
                    parent.find('.address').remove();
                    parent.find('.phones').remove();
                    parent.append(html);

                    $('#modal-address').modal('close');
                } else {
                    $.each(response.data.errors, function (i, item) {
                        $('#' + i, form).addClass('invalid');
                        M.toast({html:'<span>'+ item +'</span>'}, 5000);
                    });
                }

                self.lockAjaxForm = false;
            }).fail(function(jqXHR, textStatus) {
                self.lockAjaxForm = false;

                console.log("Request failed: " + textStatus);
            });
        });
    },
};

module.exports = new FrontDashboardHome();
